import { SELECIONAR_PARAMETROS_BUSCA_REPASSE } from '../../actions/types'

const initialState = undefined
const estadoInicial = {}

export default function reducerParametrosBuscaRepasseSelecionado (state = estadoInicial, action = initialState) {
  switch (action.type) {
    case SELECIONAR_PARAMETROS_BUSCA_REPASSE: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}